const Innocuous = () => {
    const pageWidth = "100%";
    const bookUri = "Innocuous.pdf";
    return ( 
        <div>
            <h1>Innocuous</h1>
            <embed width={pageWidth} height={"500vh"} src={bookUri}></embed>
        </div>
     );
}
 
export default Innocuous;